import React, {useMemo} from 'react';
import {useAppSelector} from '../../store/hooks';
import {useWindowDimensions, View} from 'react-native';
import {Chip, Text} from 'react-native-paper';
import {useQuery} from 'react-query';
import {useNavigation, useRoute} from '@react-navigation/native';
import {ProjectParams} from '../../types/nav';
import {getFolderContent} from '../../api';
import {EditorComment} from '../../types';

export function EditorRuler() {
  const editor = useAppSelector(state => state.editor);
  const {pixelsPerSecond} = editor;
  const {width} = useWindowDimensions();
  const params = useRoute().params as ProjectParams;
  const commentsReq = useQuery(
    params.projectId + '_comments',
    async () => {
      return (await getFolderContent(
        params.projectId + '_comments',
        params.mnemonic,
      )) as EditorComment[];
    },
  );
  const comments = commentsReq.data;
  const [increments, offsetLeft] = useMemo(() => {
    const seconds = width / pixelsPerSecond;
    const inc: number[] = [];
    while (inc.length < seconds) {
      const last = inc.length;
      inc.push(last + 1);
    }
    // console.info('pixelspersecond', pixelsPerSecond)
    const incs = inc.filter(i => {
      if (pixelsPerSecond < 1) return i % 60 === 0;
      if (pixelsPerSecond < 2) return i % 30 === 0;
      if (pixelsPerSecond < 4) return i % 10 === 0;
      return true;
    });
    let offset = pixelsPerSecond;
    if (pixelsPerSecond < 4) {
      offset = pixelsPerSecond * 10;
    }
    if (pixelsPerSecond < 2) {
      offset = pixelsPerSecond * 30;
    }
    if (pixelsPerSecond < 1) {
      offset = pixelsPerSecond * 60;
    }
    const res = [incs, offset];
    // console.info(res)
    return res as [number[], number, {[key: number]: string[]}];
  }, [width, pixelsPerSecond]);
  const nav = useNavigation();
  return (
    <View
      style={{
        width: '100%',
        height: 10,
        top: 0,
        left: 0,
        position: 'absolute',
        display: 'flex',
        flexDirection: 'row',
        gap: offsetLeft - 1,
        zIndex: 1000,
      }}>
      {increments.map(increment => {
        return (
          <View
            key={'increment_' + increment}
            style={{
              borderColor: 'white',
              borderLeftWidth: 1,
              height: increment % 2 ? 3 : 7,
            }}>
            {increment % 5 ? null : (
              <Text
                style={{
                  position: 'absolute',
                  left: offsetLeft,
                  marginTop: 5,
                  fontSize: 10,
                }}>
                {increment}
              </Text>
            )}
          </View>
        );
      })}
      {comments?.map(comment => {
        const isSelected = params.chatId === comment.id;
        return (
          <View
            style={{
              position: 'absolute',
              left:
                pixelsPerSecond *
                (comment.currentPosition || comment.orderId),
            }}>
            <Chip
              selected={isSelected}
              icon={'comment'}
              style={{
                backgroundColor: 'black',
                borderWidth: isSelected ? 1 : 0,
                borderColor: 'white',
              }}
              showSelectedCheck={false}
              showSelectedOverlay={isSelected}
              key={'comment_' + comment.id}
              onPress={() =>
                nav.setParams({
                  ...params,
                  encoder: undefined,
                  chatId:
                    params.chatId === comment.id
                      ? undefined
                      : comment.id,
                })
              }>
              <Text style={{fontSize: 12}}>
                {comment.name
                  .split(' ')
                  .map(i => i[0])
                  .join('')}
              </Text>
            </Chip>
          </View>
        );
      })}
    </View>
  );
}
